<template>
  <v-card class="mx-auto my-0">
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel key="0">
        <v-expansion-panel-header>
          {{ $t("immediateSyncs") }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <span style="color: green"
          >{{ $t("nowYouHave") }}
            {{ this.$store.state.membership.immediateSyncs }}
          </span>
          <br/>
          <v-row>
            <v-col :sm="changedImmediateSyncsPrice === 0 ? 12 : 9" cols="12">
              <div class="d-flex">
                <span class="mt-1"> {{ $t("immediateSyncsToBuy") }} </span>
                <v-text-field
                    v-model="chosenNumberOfImmediateSyncs"
                    :value="0"
                    class="ml-3 mt-0 pt-0"
                    single-line
                    dense
                    type="number"
                    :min="0"
                    :step="IMMEDIATE_SYNC.number"
                    @change="chosenNumberOfImmediateSyncsErrorMessages"
                    :error-messages="chosenNumberOfImmediateSyncsErrorMessages"
                    style="max-width: 70px"
                ></v-text-field>
              </div>
            </v-col>
            <v-col
                :sm="changedImmediateSyncsPrice === 0 ? 0 : 3"
                cols="12"
                class="text-right mt-n5 mt-sm-0"
                v-if="changedImmediateSyncsPrice !== 0"
            >
              {{ $t("quickMembershipResume.price") }}
              ${{ changedImmediateSyncsPrice }}
            </v-col>
          </v-row>

          <v-row style="margin-top: 0">
            <v-col :sm="12" cols="12">
              <v-form class="d-flex">
                <v-spacer/>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div style="height: 33px" v-bind="attrs" v-on="on">
                      <v-btn
                          style="margin-top: 2px"
                          class="ml-3"
                          @click="buttonClicked"
                          :loading="isButtonLoading"
                          :disabled="changedImmediateSyncsPrice === 0 || chosenNumberOfImmediateSyncs % IMMEDIATE_SYNC.number !== 0"
                      >
                        {{ $t("buttons.buyImmediateSyncs") }}
                        <template v-slot:loader>
                        <span class="custom-loader">
                          <v-icon light>mdi-cached</v-icon>
                        </span>
                        </template>
                      </v-btn>
                    </div>
                  </template>
                  <span v-if="chosenNumberOfImmediateSyncs % IMMEDIATE_SYNC.number !== 0"> {{
                      $t("toolTips.buyImmediateSyncsInvalid")
                    }} </span>
                  <span v-else-if="changedImmediateSyncsPrice === 0"> {{ $t("toolTips.buyImmediateSyncsZero") }} </span>
                  <span v-else> {{ $t("toolTips.buyImmediateSyncs") }} </span>
                </v-tooltip>
                <v-spacer/>
              </v-form>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-snackbar right top app color="error" v-model="buyClickedError">
      {{ $t("notificationSnackbars.unableToBuyImmediateSyncs") }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="buyClickedError = false">
          {{ $t("buttons.close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
// EventBus is defined in timer2ticket-client-vue project
import {EventBus} from "@/EventBus";
import {IMMEDIATE_SYNC} from "../../enums/membership/typeOfMembership"
import {getBuyImmediateSyncsLink} from "../../backendService.js";

export default {
  data() {
    return {
      panel: [],
      chosenNumberOfImmediateSyncs: 0,
      isButtonLoading: false,
      buyClickedError: false,
    };
  },
  created() {
    EventBus.$on("immediate-syncs-open", () => {
      this.panel = [0];
    });
  },
  computed: {
    IMMEDIATE_SYNC() {
      return IMMEDIATE_SYNC
    },
    changedImmediateSyncsPrice() {
      if (this.chosenNumberOfImmediateSyncs % IMMEDIATE_SYNC.number !== 0) {
        return 0; // If invalid number of immediate syncs is chosen, price is 0.
      }
      return this.chosenNumberOfImmediateSyncs / IMMEDIATE_SYNC.number * IMMEDIATE_SYNC.price; // Chosen price calculation.
    },
    chosenNumberOfImmediateSyncsErrorMessages() {
      const errorMessages = [];
      if (this.chosenNumberOfImmediateSyncs % IMMEDIATE_SYNC.number !== 0) {
        errorMessages.push(this.$t("rules.immediateSyncsMustBeMultipleOf") + IMMEDIATE_SYNC.number.toString());
      }
      return errorMessages;
    }
  },
  methods: {
    async buttonClicked() {
      this.isButtonLoading = true;
      const response = await getBuyImmediateSyncsLink(this.chosenNumberOfImmediateSyncs);
      if (!response) {
        this.buyClickedError = true;
        // Stop showing loading button only when there is an error (no redirect)
        this.isButtonLoading = false;
      } else {
        window.location.href = response;
      }
    },
  },
};
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
